module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-13.b2923c9c.png";